import {
  createAccessService,
  GrantableAccessRole,
  ShareAccessRequest,
} from '@/services/shared/create-access-service';

export type GrantableContextGraphRole = GrantableAccessRole;
export type ShareContextGraphRequest = ShareAccessRequest;

const contextGraphAccess = createAccessService({
  pathSegment: 'context-graph-access',
  sentryContext: 'context-graph-access',
  notGrantedReason: 'Not granted (not an org member?)',
});

export const shareContextGraph = contextGraphAccess.share;
export const listContextGraphAccess = contextGraphAccess.listAccess;
export const updateContextGraphRole = contextGraphAccess.updateRole;
export const revokeContextGraphAccess = contextGraphAccess.revokeAccess;
